import React from "react";
import Title from "../../../components/title/Title";
import { MainContainer } from "../../styles/sharedStyles";
import Section from "../../../components/section/Section";
import { tokens } from "../../../../theme";
import {
  Grid,
  Typography,
  Box,
  useTheme,
  Paper,
  useMediaQuery,
} from "@mui/material";

import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import FormulaireDebutCoaching from "./FormulaireDebutCoaching";

const FormulaireDebutCoachingMainPage = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Check if it's a mobile screen

  return (
    <MainContainer>
      <Title title="Formulaire de début de Coaching" summary="Formulaire" />
      <Section>
        <Paper elevation={3} style={{ padding: "2rem" }}>
          <Typography
            variant="body1"
            color={colors.grey[100]}
            align="left"
            display="block"
          >
            Ce formulaire est un peu plus détaillé que celui que tu as rempli
            lorsque tu m’as contacté, mais il est essentiel pour que je puisse
            vraiment te connaître. 📝<br></br> Grâce à tes réponses, je vais
            pouvoir te créer un programme parfaitement adapté à tes besoins, à
            tes objectifs, et à ton style de vie. 🎯✨<br></br> Si jamais tu as
            des questions ou besoin d’éclaircissements, n’hésite surtout pas à
            m’envoyer un message sur whatsapp 💬😊
          </Typography>
        </Paper>
      </Section>

      <Box
        m={isMobile ? 1 : 2} // Adjust margin for mobile screens
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Grid container justifyContent="center">
          <Grid
            item
            xs={12}
            sm={10}
            md={8}
            lg={6}
            sx={{
              padding: isMobile ? "1rem" : "2rem", // Add padding for better spacing
            }}
          >
            {" "}
            <FormulaireDebutCoaching />
          </Grid>
        </Grid>
      </Box>
    </MainContainer>
  );
};

export default FormulaireDebutCoachingMainPage;
